import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
// components
import { openLoader, closeLoader } from '../components/loader/actions';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAvailableDocumentTypes = (props) => {
  const {
    callback,
    branchGuid,
    openLoader,
    closeLoader,
    shouldNotGet,
  } = props;

  const [availableDocumentTypes, setAvailableDocumentTypes] = useState([]);

  useEffect(() => {
    const handleGetAvailableDocumentTypes = async () => {
      if (shouldNotGet) return;

      G.callFunction(openLoader);

      const options = {
        params: {
          [GC.FIELD_BRANCH_GUID]: R.or(branchGuid, G.getAmousCurrentBranchGuidFromWindow()),
        },
      };

      const res = await sendRequest('get', endpointsMap.availableDocumentTypes, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        const mapped = R.map(({ displayedValue, ...item }) => ({
          ...item,
          displayedValue,
          [GC.FIELD_LABEL]: displayedValue,
          [GC.FIELD_VALUE]: G.getParentGuidOrGuidFromObject(item),
        }), R.or(data, []));

        setAvailableDocumentTypes(mapped);

        G.callFunctionWithArgs(callback, mapped);
      } else {
        G.handleException(res, 'useAvailableDocumentTypes exception');
      }

      G.callFunction(closeLoader);
    };

    handleGetAvailableDocumentTypes();
  }, []);

  return { availableDocumentTypes };
};

const useAsyncDocumentTemplates = (props) => {
  const {
    callback,
    branchGuid,
    openLoader,
    closeLoader,
    shouldNotGet,
  } = props;

  const [asyncDocumentTemplates, setAsyncDocumentTemplates] = useState([]);

  useEffect(() => {
    const handleGetAsyncDocumentTemplates = async () => {
      if (shouldNotGet) return;

      G.callFunction(openLoader);

      const options = {
        params: {
          [GC.FIELD_BRANCH_GUID]: R.or(branchGuid, G.getAmousCurrentBranchGuidFromWindow()),
        },
      };

      const res = await sendRequest('get', endpointsMap.availableDocumentTemplates, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        const grouped = R.groupBy(R.prop(GC.FIELD_PRINTABLE_SECTION), R.or(data, []));

        setAsyncDocumentTemplates(grouped);

        G.callFunctionWithArgs(callback, grouped);
      } else {
        G.handleException(res, 'useAvailableDocumentTypes exception');
      }

      G.callFunction(closeLoader);
    };

    handleGetAsyncDocumentTemplates();
  }, []);

  return { asyncDocumentTemplates };
};

const useGetServiceVendorsByType = ({
  types,
  branchGuid,
  createOptions,
  initialValues,
  shouldNotGetServiceVendors,
}) => {
  const [serviceVendors, setServiceVendors] = useState(R.or(initialValues, []));

  const dispatch = useDispatch();

  useEffect(() => {
    const handleGetServiceVendors = async () => {
      if (shouldNotGetServiceVendors) return;

      dispatch(openLoader());

      const options = {
        params: {
          [GC.BRANCH_GUID]: R.or(branchGuid, G.getAmousCurrentBranchGuidFromWindow()),
          types: G.isArray(types) ? R.join(',', types) : GC.SERVICE_VENDOR_TYPE_GENERAL,
        },
      };

      const res = await sendRequest('get', endpointsMap.serviceVendorListAvailable, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setServiceVendors(createOptions ? G.mapNameGuidObjectPropsToLabelValueObject(data) : data);
      } else {
        G.handleFailResponseSimple(res);
      }

      dispatch(closeLoader());
    };

    handleGetServiceVendors();
  }, [shouldNotGetServiceVendors]);

  return serviceVendors;
};

export {
  useAvailableDocumentTypes,
  useAsyncDocumentTemplates,
  useGetServiceVendorsByType,
};

